import { Component, Input } from '@angular/core';
import { Story, StoryType } from '../../interfaces/story';

@Component({
  selector: 'anon-story-title',
  templateUrl: './story-title.component.html',
  styleUrls: ['./story-title.component.scss']
})
export class StoryTitleComponent {
  @Input() type: StoryType = 'article';
  @Input() status: Story["problemStatus"];
}
